(function () {
    angular
        .module('processModule', ['ui.bootstrap', 'ui.router'])
        .run(['$location', '$state', 'pubSub', 'documentService', 'tabStateService', '$rootScope', function ($location, $state, pubSub, documentService, tabStateService, $rootScope) {
            window.addEventListener("message", (event) => {
                if (!event.data || event.data.moduleName != 'process' || !event.data.eventName)
                    return;
                
                let backendRoute = '';
                switch (event.data.eventName) {
                    case 'process-route-change':
                        let frontendRoute = event.data.value.toLowerCase();
                        let areaIdTarget = null;
                        let processNumberTarget = null;
                        let processClassificationTarget = null;

                        if (frontendRoute.indexOf('process/home/details') > -1) {
                            backendRoute = '/process-fe/home/root-details';
                            $state.go('areas-root-view')
                        }
                        else if (frontendRoute.indexOf('process/area/detail') > -1) {
                            backendRoute = '/process-fe' + frontendRoute.replace('process', '');
                            let areaId = backendRoute.substring(backendRoute.lastIndexOf('/') + 1);
                            if (areaId.indexOf('?isfrontend') > -1) {
                                areaId = areaId.substring(0, areaId.indexOf('?isfrontend'));
                            }
                            if (areaId && areaId != '') {
                                areaIdTarget = areaId;
                            }
                        }
                        else if (frontendRoute.indexOf('process/process-detail/management') > -1) {
                            let processNumber = frontendRoute.substring(frontendRoute.lastIndexOf('/') + 1);
                            if (processNumber.indexOf('?isfrontend') > -1) {
                                processNumber = processNumber.substring(0, processNumber.indexOf('?isfrontend'));
                            }
                            if (processNumber && processNumber != '') {
                                processNumberTarget = processNumber;
                                backendRoute = '/process-fe/process-detail/' + processNumber;
                            }
                            processClassificationTarget = E.processClassificationTypes.Processes;
                        }
                        else if (frontendRoute.indexOf('process/process-interconnected/management') > -1) {
                            let processNumber = frontendRoute.substring(frontendRoute.lastIndexOf('/') + 1);
                            if (processNumber.indexOf('?isfrontend') > -1) {
                                processNumber = processNumber.substring(0, processNumber.indexOf('?isfrontend'));
                            }
                            if (processNumber && processNumber != '') {
                                processNumberTarget = processNumber;
                                backendRoute = '/process-fe/process-interconnected/' + processNumber;
                            }
                            processClassificationTarget = E.processClassificationTypes.ProcessInterconnected;
                        }
                        else if (frontendRoute.indexOf('process/process-detail/viewsendtohearing') > -1 ||
                                frontendRoute.indexOf('process/process-interconnected/viewsendtohearing') > -1) {
                            backendRoute = '/process-fe' + frontendRoute.replace('process', '');                    
                            let processNumber = backendRoute.substring(backendRoute.lastIndexOf('/') + 1);
                            if (processNumber) {
                                processNumberTarget = processNumber;
                            }
                        }
                        pubSub.publish(broadcastType.processAreaRouteChanged, {
                            areaId: areaIdTarget,
                            processNumber: processNumberTarget,
                            processClassification: processClassificationTarget
                        });
                        break;
                    case 'go-to-handbook-home':
                        backendRoute = '/';
                        $state.go('home');
                        break;
                    case 'open-full-screen-diagram':
                        documentService.showFullscreen();
                        break;
                    case 'close-full-screen-diagram':
                        documentService.showNormal();
                        tabStateService.adjustContentHeightPosition(tabStateType.documentTabState);
                        $('#document-content-identifier').css('margin-top', '0px');
                        break;
                    case 'hide-navigation-bar':
                        angular.element('#dropdownusername').removeClass('open');
                        if (angular.element('.activity-notifications > div').css('display') === 'block') {
                            angular.element('.activity-notifications > div').css('display', 'none');
                        }
                        break;
                    case 'update-favorites-processes':
                        pubSub.publish(broadcastType.updateFavoritesProcesses, true);
                        break;
                    case 'rebuild-tree-view':
                        // pubSub.publish(broadcastType.rebuildTreeView);
                        break;
                    case 'start-loading-spinner':
                        var loadingSpinner = document.getElementById('ng-loading-spinner');
                        if (loadingSpinner)
                            loadingSpinner.style.display = 'block';
                        break;
                    case 'stop-loading-spinner':
                        var loadingSpinner = document.getElementById('ng-loading-spinner');
                        if (loadingSpinner)
                            loadingSpinner.style.display = 'none';
                        break;
                    case 'update-document-title':
                        $rootScope.$apply(function () {
                            $rootScope.title = globalResources.Handbook + " - " + event.data.value;
                            $rootScope.metaDescription = event.data.value;
                        });
                        break;
                    default:
                        backendRoute = '/';
                }

                if (!backendRoute) return;

                let url = $location.url();

                if (backendRoute.indexOf('?isfrontend') > -1) {
                    backendRoute = backendRoute.substring(0, backendRoute.indexOf('?isfrontend'));
                }
                if (url === backendRoute) return;
                if (!history.state || !history.state.id || (history.state.id !== backendRoute)) {
                    history.pushState({ id: backendRoute }, backendRoute, backendRoute);
                }
            });
        }]);
})();